import { SVGProps } from 'react'
import { DebtRecordRevampedType } from '../types/debtOverviewApi.types'
import {
	BankLoan,
	CarLoan,
	CreditCardLoan,
	HomeLoan,
	StudentLoan,
	UnknownLoan,
} from '@monthio/icons'

export const debtFallbackImageSrc = (
	debtType: DebtRecordRevampedType,
): ((props: SVGProps<SVGSVGElement>) => JSX.Element) => {
	switch (debtType) {
		case DebtRecordRevampedType.BankLoan:
			return BankLoan
		case DebtRecordRevampedType.CarLoan:
			return CarLoan
		case DebtRecordRevampedType.CreditCard:
			return CreditCardLoan
		case DebtRecordRevampedType.MortgageByCreditInstitution:
		case DebtRecordRevampedType.MortgageByBank:
			return HomeLoan
		case DebtRecordRevampedType.StudentLoan:
			return StudentLoan
		default:
			return UnknownLoan
	}
}
